module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/logo_banner/image 004-088f526fef339f9035a1dead5bbe51ad.png";